import {PromotionReview} from './PromotionReview'

/**
 * @param {{
 *  promotion: import('@/types/promotion').Promotion,
 *  setCurrentStep: (step: import('@/types/promotion').PromotionStep) => void,
 * }} props
 */
export const PromotionReviewStep = ({promotion, setCurrentStep}) => {
  return <PromotionReview data={promotion} setCurrentStep={setCurrentStep} />
}
